import Order from 'communication/types/order/Order';
import { TradeOptimizerOrder } from 'widgets/tradeOptimizer/types';

export function toTradeOptimizerOrder(order: Order): TradeOptimizerOrder {
    return {
        orderID: order.orderID,
        symbol: order.localSymC,
        side: order.side,
        qty: order.qty,
        fillQty: order.fillQty,
        rem: order.rem,
        limit: order.limit,
        curcy: order.curcy,
        state: order.state,
    };
}
